/**
 * usePermissions Hook
 * Provides easy access to permission checking functions
 */

import { useAuth } from '../context/AuthContext';
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  canViewModule,
  canCreate,
  canEdit,
  canDelete,
  canExport,
  getAccessibleModules,
  getModuleActions
} from './permissions';

export function usePermissions() {
  const { user } = useAuth();

  return {
    user,
    hasPermission: (permission) => hasPermission(user, permission),
    hasAnyPermission: (permissions) => hasAnyPermission(user, permissions),
    hasAllPermissions: (permissions) => hasAllPermissions(user, permissions),
    canViewModule: (moduleName) => canViewModule(user, moduleName),
    canCreate: (moduleName) => canCreate(user, moduleName),
    canEdit: (moduleName) => canEdit(user, moduleName),
    canDelete: (moduleName) => canDelete(user, moduleName),
    canExport: (moduleName) => canExport(user, moduleName),
    getAccessibleModules: () => getAccessibleModules(user),
    getModuleActions: (moduleName) => getModuleActions(user, moduleName),
    isSuperAdmin: () => Boolean(user?.role_name === 'Super Admin' && Array.isArray(user?.permissions) && user.permissions.length > 0),
  };
}

export default usePermissions;
